module.exports = __webpack_public_path__ + "static/media/feed.9bb119dc.svg";